import { render } from "./TypeDate.vue?vue&type=template&id=0464a370&ts=true"
import script from "./TypeDate.vue?vue&type=script&lang=ts"
export * from "./TypeDate.vue?vue&type=script&lang=ts"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__